export const LandlordPaymentModel = {
  ANNUAL: 'ANNUAL',
  MONTHLY: 'MONTHLY',
  PER_CP: 'PER_CP',
} as const;

export type LandlordPaymentModel =
  (typeof LandlordPaymentModel)[keyof typeof LandlordPaymentModel];
